import type { Comment as CommentType } from '@/@types/comment'
import { type GetCommentParams, getCommentQueryOptions } from '@/utils/fetchers/comment'
import usePost from '@/utils/hooks/usePost'
import { useSuspenseQuery } from '@tanstack/react-query'
import type { HTMLMotionProps } from 'motion/react'
import CommentActions from './CommentActions'
import CommentThread from './CommentThread'
import { useToCommentPage } from './hooks'

export type CommentData = GetCommentParams

export interface CommentProps extends HTMLMotionProps<'div'> {
	data: CommentData
	noActions?: boolean
	noReplies?: boolean
	noSuffixTitle?: boolean
	showThreadLine?: boolean
}

export default function Comment({
	data: commentQueryParams,
	noActions = false,
	noReplies = false,
	noSuffixTitle = false,
	showThreadLine = false,
	...props
}: CommentProps) {
	const { data } = useSuspenseQuery<CommentType>(getCommentQueryOptions(commentQueryParams))
	const targetPost = usePost(data.targetId)
	const { canToCommentPage, toCommentPage } = useToCommentPage(data)
	const isPostAuthor = targetPost?.user?.username === data.user.username
	const renderReply = (commentData: CommentData) => <Comment data={commentData} />

	return (
		<CommentThread
			actions={noActions ? undefined : <CommentActions data={data} />}
			clickable={canToCommentPage}
			data={data}
			isPostAuthor={isPostAuthor}
			noSuffixTitle={noSuffixTitle}
			renderReply={!noReplies && !noActions ? renderReply : undefined}
			showThreadLine={showThreadLine}
			onClick={toCommentPage}
			{...props}
		/>
	)
}
